import api from './api';

/**
 * Handbook Sections Service
 * For the interactive, section-based handbook system
 */

// ============================================
// PUBLIC ENDPOINTS (No auth required)
// ============================================

// Get all handbook sections (for app)
export const getHandbookSections = async () => {
  const response = await api.get('/handbook/sections');
  return response.data;
};

// Get single section by ID
export const getHandbookSection = async (id) => {
  const response = await api.get(`/handbook/sections/${id}`);
  return response.data;
};

// Get table of contents (lightweight)
export const getHandbookTOC = async () => {
  const response = await api.get('/handbook/toc');
  return response.data;
};

// ============================================
// AUTHENTICATED ENDPOINTS
// ============================================

// Track reading progress
export const markSectionRead = async (sectionId, timeSpentSeconds = 0) => {
  const response = await api.post(`/handbook/sections/${sectionId}/read`, {
    time_spent_seconds: timeSpentSeconds
  });
  return response.data;
};

// Acknowledge a section
export const acknowledgeSection = async (sectionId) => {
  const response = await api.post(`/handbook/sections/${sectionId}/acknowledge`);
  return response.data;
};

// Get user's reading progress
export const getReadingProgress = async () => {
  const response = await api.get('/handbook/progress');
  return response.data;
};

// ============================================
// ADMIN ENDPOINTS
// ============================================

// Get all sections (admin - includes inactive)
export const getAdminSections = async () => {
  const response = await api.get('/handbook/admin/sections');
  return response.data;
};

// Create new section
export const createSection = async (sectionData) => {
  const response = await api.post('/handbook/admin/sections', sectionData);
  return response.data;
};

// Update section
export const updateSection = async (id, sectionData) => {
  const response = await api.put(`/handbook/admin/sections/${id}`, sectionData);
  return response.data;
};

// Delete section (soft delete)
export const deleteSection = async (id) => {
  const response = await api.delete(`/handbook/admin/sections/${id}`);
  return response.data;
};

// Reorder sections
export const reorderSections = async (orderArray) => {
  const response = await api.put('/handbook/admin/sections/reorder', { order: orderArray });
  return response.data;
};

// Bulk import sections (for Claude Code sync)
export const importSections = async (sections, version, replaceAll = false) => {
  const response = await api.post('/handbook/admin/sections/import', {
    sections,
    version,
    replace_all: replaceAll
  });
  return response.data;
};

// Get employee completion stats
export const getCompletionStats = async () => {
  const response = await api.get('/handbook/admin/completion-stats');
  return response.data;
};

// ============================================
// LEGACY PDF ENDPOINTS
// ============================================

// Get current handbook PDF
export const getCurrentHandbook = async () => {
  const response = await api.get('/handbook/current');
  return response.data;
};

// Get public handbook URL
export const getPublicHandbookUrl = async () => {
  const response = await api.get('/handbook/public');
  return response.data;
};

export default {
  // Public
  getHandbookSections,
  getHandbookSection,
  getHandbookTOC,
  
  // Authenticated
  markSectionRead,
  acknowledgeSection,
  getReadingProgress,
  
  // Admin
  getAdminSections,
  createSection,
  updateSection,
  deleteSection,
  reorderSections,
  importSections,
  getCompletionStats,
  
  // Legacy
  getCurrentHandbook,
  getPublicHandbookUrl
};
